const convertSignupRedirect = (url, redirectPath) => {
    if (!url || !redirectPath) {
        throw new Error('URL und redirectPath sind erforderlich');
    }

    if (url.includes("/at")) {
        return "/at" + redirectPath;
    } else if (url.includes("/ch")) {
        return "/ch" + redirectPath;
    }
    return redirectPath;
}

const getFormJSON = (form) => {
    if (!form) {
        throw new Error('Form-Element ist erforderlich');
    }

    const data = new FormData(form);
    return Array.from(data.keys()).reduce((result, key) => {
        result[key] = data.get(key);
        return result;
    }, {});
};

const getLastQuery = (storage = sessionStorage, location = document.location) => {
    try {
        const last_utm_query = storage.getItem("last_utm_query");
        if (last_utm_query) {
            const parsed = JSON.parse(last_utm_query);
            return parsed.query || location.search.substring(1);
        }
        return location.search.substring(1);
    } catch (error) {
        console.error('Fehler beim Lesen der Query:', error);
        return location.search.substring(1);
    }
}

const getQueryParam = (param, queryString = getLastQuery()) => {
    if (!param) {
        throw new Error('Parameter ist erforderlich');
    }

    const queryParams = new URLSearchParams(queryString);
    return queryParams.get(param) || "";
}

const getGaValue = (cookies = document.cookie) => {
    if (!cookies) {
        return "";
    }

    const cookieArray = cookies.split(";");
    for (const cookie of cookieArray) {
        if (cookie.includes("_ga=")) {
            return cookie.trim().slice(4);
        }
    }
    return "";
};

export {
    convertSignupRedirect,
    getFormJSON,
    getLastQuery,
    getQueryParam,
    getGaValue,
}
